import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetTodoCount() {
  const fetchData = async () => {
    const response = await httpClient.get(`team/cash-flow/to-do/count`)
    return response.data.count
  }

  return useQuery({
    queryKey: ['todo-count'],
    queryFn: fetchData,
  })
}
